<template>
    <div>
        <div class="pingcangmask" @click="handlemask" v-show="faqshow"></div>
        <div class="nolist" v-show="!hasmsg">
            <img src="@/assets/nomsg.png" alt="">
            没有任何订单
            <p @click="loads">刷新</p>
        </div>

        <div class="isloginTips" v-show="loadingShow">
            <img src="@/assets/loading.png" alt="">
            <p>数据加载中...</p>
        </div>

        <!-- faq预付款盒子 -->
        <div class="faq" v-show="faqshow">
            <div class="faq-title">总盈亏</div>
            <div class="faq-content">
                <p>总盈亏包含手续费、库存费，不含返点。</p>
            </div>
            <div @click="removefaq" class="faq-bottom">我知道了</div>
        </div>

        <div v-show="hasmsg">
            <div class="top">
                <ul>
                    <li>
                        <p>总手数：<span>{{alllots?alllots:'0.00'}}手</span></p>
                    </li>
                    <li>
                        <p>总盈亏<img @click="handlefaq()" style="width: 16px;height: 16px;display: block;" src="@/assets/faq-icon.png" alt="">：<span>{{allyingkui?allyingkui:'0.00'}}美元</span></p>
                    </li>
                    <li>
                        <p>总返点：<span>{{allfandian?allfandian:'0.00'}}美元</span></p>
                    </li>
                </ul>
            </div>

            <!--mescroll滚动区域的基本结构-->
            <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
                <div style="padding:0 12px">
                    <div ref="directrecordwp" class="list">
                        <div class="list-item" v-for="(item,index) of dataList" :key="index">
                            <div class="water-mark" v-show="mnwatermark">模拟</div>
                            <div class="title">
                                <div class="title-left">
                                    <p :style="{backgroundColor:item.orderDirection == 0?'#FF4F36':(item.orderDirection == 1?'#17CF84':'')}">{{item.orderDirection == 0?'买入':(item.orderDirection == 1?'卖出':(item.orderDirection == 2?'限价买入':(item.orderDirection == 3?'限价卖出':(item.orderDirection==4?'止损买入':(item.orderDirection == 5?'止损卖出':(item.orderDirection == 6?'注资':'信用'))))))}}</p>
                                    <p>{{item.symbol == 'XAU' || item.symbol == 'GOLD'?'伦敦金':(item.symbol == 'XAG' || item.symbol == 'SILVER'?'伦敦银':'未知')}}</p>
                                    <p>{{item.closeLots == 0 || !item.closeLots?item.lots.toFixed(2)+'手':(item.closeLots && item.closeLots !== item.lots?item.closeLots+"/"+item.lots.toFixed(2)+'手':(item.closeLots && item.closeLots == item.lots?item.lots.toFixed(2)+'手':""))}}</p>
                                </div>
                                <div @click="handleicon(index)" class="title-time"><span>{{getTime(item.closeTime)}}</span><img  ref="mainShows"  src="@/assets/icon-down2.png" alt=""></div>
                            </div>
                            <div class="num">
                                <div class="numbox" ref="mainShow">
                                    <ul>
                                        <div class="left">
                                            <li>订单号<span>{{item.ticket}}</span></li>
                                            <li>止损<span>{{item.stopLoss?item.stopLoss:'未设置'}}</span></li>
                                        </div>
                                        <div class="right">
                                            <li>建仓<span>{{getTime(item.openTime,'y')}}</span></li>
                                            <li>止盈<span>{{item.takeProfit?item.takeProfit:'未设置'}}</span></li>
                                        </div>
                                    </ul>
                                    <div class="zj" v-show="item.comment">备注<span>{{item.comment}}</span></div>
                                </div>
                            </div>
                            <div class="open">
                                <div class="open-left">
                                    <ul>
                                        <div class="left">
                                            <li><span>建仓</span><span>{{item.symbol == 'XAU' || item.symbol == 'GOLD'?item.openPrice.toFixed(2):(item.symbol == 'XAG' || item.symbol == 'SILVER'?item.openPrice.toFixed(3):item.openPrice.toFixed(2))}}</span></li>
                                            <li><span>平仓</span><span>{{item.symbol == 'XAU' || item.symbol == 'GOLD'?item.closePrice.toFixed(2):(item.symbol == 'XAG' || item.symbol == 'SILVER'?item.closePrice.toFixed(3):item.closePrice.toFixed(2))}}</span></li>
                                        </div>
                                        <div class="right">
                                            <li><span>手续费</span><span>{{item.commission.toFixed(2)}}</span></li>
                                            <li><span>库存费</span><span>{{item.swap.toFixed(2)}}</span></li>
                                        </div>
                                    </ul>
                                </div>
                                <div class="open-right">
                                    <p :style="{color:item.profit>=0?'#FF6738':'#17CF84'}">{{item.profit.toFixed(2)}}</p>
                                    <p>盈亏</p>
                                </div>
                            </div>
                            <div class="bottom" v-show="!mnwatermark">
                                <p>返点时间：{{getTime(item.closeTime)}}</p>
                                <p>返点<span>${{childfandian[index].profit?childfandian[index].profit:'0.00'}}</span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </mescroll-vue>
        </div>

    </div>
</template>

<script>
import MescrollVue from 'mescroll.js/mescroll.vue'
import Watermark from '@/utils/watermark'
import pako from 'pako'
import {historycc,historyfd,utf8ByteToUnicodeStr} from '@/utils/socket2.js';
import moment from 'moment'
import { Message } from 'element-ui';
export default {
    inject:['reload'], //注入刷新当前页依赖 来自app.vue
    name:"pingcangs",
    props:{
        datetext:{
            type:String
        },
        changetimestart:{
            type:String  
        },
        changetimeend:{
            type:String
        },
        ordertext:{
            type:String
        },
    },
    components: {
		MescrollVue // 注册mescroll组件
	},
    data(){
        return{
            mnwatermark:false,//水印
            ofd:[],
            ticketarrfd:[],//返点单号数组
            ticketarr:[],//所有单号数组
            faqshow:false,
            alllots:null,//总手数
            allyingkui:null,//总盈亏
            allfandian:null,//总返点

            arrfandian:[],//返点总条数
            childfandian:[],//渲染的条数

            loadingShow:false,

            hasmsg:false,

            pcstarttime:null,
            pcendtime:null,
            pcflag:null,

            page:0,//初始页数
            number:10,//每次加载条数
            initarr:[],

            mescroll: null, // mescroll实例对象
			mescrollDown:{
                auto:false,
                callback:this.downCallback
            }, //下拉刷新的配置. (如果下拉刷新和上拉加载处理的逻辑是一样的,则mescrollDown可不用写了)
			mescrollUp: { // 上拉加载的配置.
                auto:false,
			    callback: this.upCallback, // 上拉回调,此处简写; 相当于 callback: function(page, mescroll) { }
			    //以下是一些常用的配置,当然不写也可以的.
                 page: {
                    num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
                    size: 10 //每页数据条数,默认10
                },
                htmlNodata: '<p class="upwarp-nodata">-- 没有更多数据了 --</p>',
                noMoreSize: 5, //如果列表已无数据,可设置列表的总数量要大于5才显示无更多数据;
                            // 避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
                            // 这就是为什么无更多数据有时候不显示的原因
                empty: {
                    //列表第一页无任何数据时,显示的空提示布局; 需配置warpId才显示
                    warpId: "xxid", //父布局的id (1.3.5版本支持传入dom元素)
                    icon: "./static/mescroll/mescroll-empty.png", //图标,默认null,支持网络图
                    tip: "暂无相关数据~" //提示
                }
			},
			dataList: [] // 列表数据
        }
    },
    methods:{

        // faq
        handlefaq(){
            this.faqshow = true
        },
        removefaq(){
            this.faqshow = false
        },
        // 蒙层
        handlemask(){
            this.faqshow = false
        },
        handleicon(index){
            let _el = this.$refs.mainShow[index]		//	通过下标找到对应同级节点
            if (_el.getAttribute('class') === 'numbox') {
                _el.setAttribute('class', 'mainactive')
            } else {
                _el.setAttribute('class', 'numbox')
            }


            let _elm = this.$refs.mainShows[index]
             if (_elm.getAttribute('class') === 'collectActive') {
                 
                _elm.setAttribute('class', 'collectActived')
            } else {
                _elm.setAttribute('class', 'collectActive')
            }

        },

        // mescroll组件初始化的回调,可获取到mescroll对象
		mescrollInit (mescroll) {
			this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
		},

        // 开启websocket
        initWebpack(){

            var that = this

            that.global.ws.onmessage = this.onmessage

            if (that.global.ws && that.global.ws.readyState == 1) {

                that.loadingShow = true //开启加载提示



                if(this.datetext == null){
                    
                    let startDate = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'); //今天开始时间
                    let endDate =  moment().endOf('day').format('YYYY-MM-DD HH:mm:ss') //今天结束时间

                    historyfd(moment(startDate).format('X'),moment(endDate).format('X'),that.global.ws)

                    setTimeout(() => {

                      historycc(moment(startDate).format('X'),moment(endDate).format('X'),that.global.ws) // 发送信息给服务端

                    }, 1000)

                }else if(this.datetext == '今日'){

                    let startDate = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'); //今天开始时间
                    let endDate =  moment().endOf('day').format('YYYY-MM-DD HH:mm:ss') //今天结束时间
                    
                    historyfd(moment(startDate).format('X'),moment(endDate).format('X'),that.global.ws)

                    setTimeout(() => {

                        historycc(moment(startDate).format('X'),moment(endDate).format('X'),that.global.ws) // 发送信息给服务端

                    }, 1000)
                }else if(this.datetext == '昨日'){

                    let startDate =  moment(moment().add(-1, 'days').startOf("day").valueOf()).format("YYYY-MM-DD HH:mm:ss"); //昨日开始时间
                    let endDate =  moment(moment().add(-1, 'days').endOf('day').valueOf()).format('YYYY-MM-DD HH:mm:ss'); //昨日结束时间
                    
                    historyfd(moment(startDate).format('X'),moment(endDate).format('X'),that.global.ws)

                    setTimeout(() => {

                    historycc(moment(startDate).format('X'),moment(endDate).format('X'),that.global.ws) // 发送信息给服务端

                    }, 1000)
                }else if(this.datetext == '最近七日'){
                    // 最近七日
                    let startDate = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1)-7*3600*24*1000
                    let endDate =  new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1); //今天结束时间

                    
                    
                    historyfd(moment(startDate).format('X'),moment(endDate).format('X'),that.global.ws)

                    setTimeout(() => {

                    historycc(moment(startDate).format('X'),moment(endDate).format('X'),that.global.ws) // 发送信息给服务端

                    }, 1000)
                }else if(this.datetext == '最近一个月'){
                    // 最近一个月
                    let startDate = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1)-30*3600*24*1000
                    let endDate =  new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1); //今天结束时间

                    

                    historyfd(moment(startDate).format('X'),moment(endDate).format('X'),that.global.ws)

                    setTimeout(() => {

                    historycc(moment(startDate).format('X'),moment(endDate).format('X'),that.global.ws) // 发送信息给服务端

                    }, 1000)
                }else if(this.datetext == '最近三个月'){
                    // 最近三个月
                    let startDate = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1)-90*3600*24*1000
                    let endDate =  new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1); //今天结束时间
                    
                    historyfd(moment(startDate).format('X'),moment(endDate).format('X'),that.global.ws)
                    setTimeout(() => {

                    

                    historycc(moment(startDate).format('X'),moment(endDate).format('X'),that.global.ws) // 发送信息给服务端

                    }, 1000)
                }else if(this.datetext == '最近六个月'){
                    // 最近六个月
                    let startDate = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1)-180*3600*24*1000
                    let endDate =  new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1); //今天结束时间
                    
                    historyfd(moment(startDate).format('X'),moment(endDate).format('X'),that.global.ws)
                    setTimeout(() => {

                    historycc(moment(startDate).format('X'),moment(endDate).format('X'),that.global.ws) // 发送信息给服务端

                    }, 1000)
                }else if(this.datetext.indexOf('~')>-1){

                    // 自定义

                    var d = moment(new Date()).format('YYYY-MM-DD')

                    if(this.pcstarttime == null || this.pcstarttime == d){
                        this.pcstarttime = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');//今天开始时间
                    }

                    if(this.pcendtime == null || this.pcendtime == d){
                        this.pcendtime = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss') //今天结束时间
                    }

                    if(this.pcstarttime && this.pcendtime){

                        this.pcstarttime = this.datetext.replace(/~/g,'').slice(0,10)

                        this.pcendtime = this.datetext.replace(/~/g,'').slice(-10)

                        this.pcendtime = Number(moment(this.pcendtime).format('X')) + 86399
                        
                    }

                   

                    let startDate = this.pcstarttime
                    let endDate = this.pcendtime

                    

                    historyfd(moment(startDate).format('X'),endDate,that.global.ws)

                    setTimeout(() => {

                    historycc(moment(startDate).format('X'),endDate,that.global.ws) // 发送信息给服务端

                    }, 1000)

                }
            
            }

        },

        onmessage(evt){
            var data = atob(evt.data);
            var data2 = pako.inflateRaw(data);
            var arr = new Uint16Array(data2);
            var strData   = utf8ByteToUnicodeStr(arr);
            var obj = JSON.parse(strData)

            if(obj.act == 'get_fundeds_orders' && obj.arrs){

                obj.arrs.sort(function(a, b) {
                    let aTimeString = a['closeTime']
                    let bTimeString = b['closeTime']
                    let aTime = new Date(aTimeString).getTime()
                    let bTime = new Date(bTimeString).getTime()
                    return bTime - aTime
                });

                this.ticketarrfd = []
                this.ofd = []
                obj.arrs.forEach(element => {
                    if(element.comment.replace(/[^Deposit]/g,"").indexOf('Deposit')>-1){
                        this.$set(element,"startPage",1) //转入
                    }else if(element.comment.replace(/[^agent]/g,"").indexOf('agent')>-1){
                        this.$set(element,"startPage",2) //返点
                        this.allfandian = parseFloat(this.NumberAdd(this.allfandian,element.profit)).toFixed(2)
                        this.ticketarrfd.push(Number(element.comment.substring(element.comment.lastIndexOf("#")+1)))
                        this.ofd.push(element.profit)
                    }else if(element.comment.replace(/[^Widthd]/g,"").indexOf('Widthd')>-1){
                        this.$set(element,"startPage",3) //转出
                    }
                });

                this.arrfandian = obj.arrs //定义了初始arrfandian存储总条数

                this.childfandian = this.arrfandian.slice(this.page,this.number) //每次加载赋予值得datalist先渲染10条

                this.mescroll.endSuccess(this.childfandian.length,this.childfandian.length < this.arrfandian.length ? true : false) //判断是否有下一页

                // this.arrfandian.forEach(element => {
                //     this.allfandian = parseFloat(this.NumberAdd(this.allfandian,element.profit)).toFixed(2)
                // });
            }

            if(obj.act == 'get_close_orders' && obj.arr){

                obj.arr.sort(function(a, b) {
                    let aTimeString = a['closeTime']
                    let bTimeString = b['closeTime']
                    let aTime = new Date(aTimeString).getTime()
                    let bTime = new Date(bTimeString).getTime()
                    return bTime - aTime
                });
                this.ticketarr = []
                obj.arr.forEach(element => {

                    this.ticketarr.push(element.ticket)

                });

                this.initarr = obj.arr //定义了初始initarr存储总条数
                this.dataList = this.initarr.slice(this.page,this.number) //每次加载赋予值得datalist先渲染10条
                this.hasmsg = true //是否有订单

                this.$toast('加载成功');

                this.mescroll.endSuccess(this.dataList.length,this.dataList.length < this.initarr.length ? true : false) //判断是否有下一页

                this.$store.state.pcconfirm = false //关闭开关

                this.loadingShow = false //关闭loading
                
            }else if(obj.act == 'get_close_orders' && !obj.arr){
                this.$toast(obj.msg)
                this.hasmsg = false //是否有订单
                this.$store.state.pcconfirm = false //关闭开关
                this.loadingShow = false //关闭loading
            }

            // this.ticketarrfd a数组单号  
            // this.ticketarr b数组单号 
            // this.ofd a数组返点 
            // this.childfandian 需要渲染的返点数 

             this.childfandian = this.ticketarr.map(item =>{
                 return{
                     ticket:item,
                     profit:null
                 }
             })

            this.ticketarrfd.map((item,index) =>{
                this.ticketarr.some((m,n)=>{
                     if(m == item){
                         this.childfandian[n].profit = this.ofd[index].toFixed(2)
                         return true
                     }
                 })
            })

            // 全局订单推送
            if(obj.act == 'order_update'){

                if(this.$store.state.login){

                    this.$store.state.ordertipshow = true

                    this.$store.state.ordertype = obj.msg.replace(/[0-9]/g,"")
             

                    this.$store.state.orderticket = obj.msg.replace(/[^\d.]/g,"");
                    this.$store.state.ordersymbol = obj.data.symbol
                    this.$store.state.orderdeal = obj.data.orderDirection
                    this.$store.state.orderopenprice = obj.data.openPrice
                    this.$store.state.ordercloseprice = obj.data.closePrice
                    this.$store.state.orderlots = obj.data.lots
                    this.$store.state.orderopentime = obj.data.openTime
                    this.$store.state.orderclosetime = obj.data.closeTime

                    setTimeout(() => {

                        this.$store.state.ordertipshow = false
                

                    }, 5000)
                }
            }

        },

        upCallback (page, mescroll) {
            
            // initarr
            const getlist = this.initarr.slice(this.dataList.length, this.dataList.length + 10)

            this.dataList = this.dataList.concat(getlist)



            // arrfandian
            const getlistfandian = this.arrfandian.slice(this.childfandian.length, this.childfandian.length + 10)
            this.childfandian = this.childfandian.concat(getlistfandian)

            this.$nextTick(() => {
                mescroll.endSuccess(getlist.length,this.dataList.length < this.initarr.length ? true : false)
            })

	    },

        downCallback (mescroll) {
            this.alllots = null
            this.allyingkui = null
            this.allfandian = null
            this.initWebpack()

	    },
        
        // 刷新
        loads(){
            this.alllots = null
            this.allyingkui = null
            this.allfandian = null
            this.initWebpack()
        },

        NumberAdd(arg1, arg2){
            var r1,r2,m,n
            try{
                r1 = arg1.toString().split('.')[1].length
            } catch (e){
                r1 = 0
            }
            try{
                r2 = arg2.toString().split('.')[1].length
            } catch (e){
                r2 = 0
            }
            m = Math.pow(10, Math.max(r1, r2))
            n = ( r1 >= r2 ) ? r1 : r2
            return ((arg1 * m + arg2 * m ) / m ).toFixed(n)
        },

        
    },

    watch:{
        'datetext'(val){
            if(val){
                this.alllots = null
                this.allyingkui = null
                this.allfandian = null
                this.initWebpack()
            }

        },
        'changetimestart'(val){
            this.pcstarttime = val
        },
        'changetimeend'(val){
            this.pcendtime = val
        },
        'ordertext'(val){
            val = '平仓订单'
        },
        'initarr'(val){
            val.forEach(element => {
                this.alllots = parseFloat(this.NumberAdd(this.alllots,element.lots)).toFixed(2)
                this.allyingkui = Number(this.allyingkui)
                this.allyingkui = parseFloat(this.allyingkui + element.profit + element.commission + element.swap).toFixed(2)
            });
        },
    },
    
    computed:{

    },

    mounted(){
        this.initWebpack()
        // 加水印
        if(this.$store.state.mnlogin){
            this.mnwatermark = true
        }else{
            this.mnwatermark = false
        }

        // 禁止浏览器自带返回
        history.pushState(null, null, document.URL);
        window.addEventListener('popstate', function () {
            history.pushState(null, null, document.URL);
        });

    }
}
</script>

<style scoped>
    body{touch-action: none;}
    .pingcangmask{background: #000000;width: 100%;height: 100%;opacity: 0.5;position: fixed;left: 0;top: 0;z-index: 887;}

    /* 水印 */
    .water-mark{color:rgba(200, 200, 200, 0.80);font-size: 30px;position: absolute;bottom: 30px;right: 75px;}
    
    li{list-style: none;}
    .nolist{color: #999999;font-size:14px;text-align: center;margin-top: 30%;}
    .nolist img{width: 240ox;height: 120px;margin: 0 auto;display: block;}
    .nolist p{border-radius: 20px;color: #FFFFFF;display: flex;justify-content: center;align-items: center;background-image: linear-gradient(to right, #FF6738, #FF4F36);height: 34px;width: 60px;margin: 15px auto;}
    .top{border-radius: 6px;padding: 0 12px;}
    .top ul{height: 38px;background-color: #FFFFFF;display: flex;justify-content: space-between;align-items: center; overflow-x: auto;display: -webkit-box;-webkit-overflow-scrolling: touch;padding-right: 12px;}
    .top ul::-webkit-scrollbar {display: none;}
    .top ul li{text-align: center;padding-left: 12px;}
    .top ul li p{color: #999999;font-size: 14px;display: flex;align-items: center;}
    .top ul li p span{color: #333333;font-size: 14px;font-weight: bold;}

    .list-box{padding-bottom: 20px;}
    .list{border-radius: 12px;margin-top: 10px;}
    .list-item{background-color: #FFFFFF;padding: 12px 12px 9px 12px;margin-top: 10px;position: relative;}
    .title{display: flex;justify-content: space-between;align-items: center;}
    .title-left{display: flex;justify-content: flex-start;align-items: center;}
    .title-left p:nth-of-type(1){width: 36px;height: 18px;display: flex;justify-content: center;align-items: center;color: #FFFFFF;font-size: 12px;background-color: #17CF84;margin-right: 6px;border-radius: 9px;}
    .title-left p:nth-of-type(2){margin-right: 9.33px;font-size: 16px;font-weight: bold;color: #333333;}
    .title-left p:nth-of-type(3){font-size: 16px;font-weight: bold;color: #333333;}

    @media screen and (max-width: 320px) {
        .title-left p:nth-of-type(2),.title-left p:nth-of-type(3){font-size: 12px;}
    }

    .title-time{color: #BBBBBB;font-size: 12px;display: flex;align-items: center;}
    .title-time span:nth-of-type(1){padding-right: 3px;}
    .title-time img{width: 24px;height: 24px;}
    .numbox{padding: 13.33px 0 14.33px 12px;background-color: #F8F8F8;margin-top:11.67px;display: none;}
    .num ul{display: flex;justify-content: flex-start;flex-wrap: wrap;align-items: flex-start}
    .num ul li{width: 142px; display: flex;align-items: center;font-size: 14px;color: #999999;}
    .num ul li:nth-of-type(1),.num ul li:nth-of-type(2){margin: 0;}
    .num ul li span{color: #333333;font-size: 14px;padding-left: 10px;}
    .num ul li span:nth-of-type(2){padding-left: 9.67px;color: #333333;}
    .num .zj{color: #333333;font-size: 14px;line-height: 28px}
    .num .zj span{margin-left: 10px;}

    .collectActive{transform: rotate(180deg);transition: all 0.5s;}
    .collectActived{transform: rotate(0deg);transition: all 0.5s;}
    .mainactive{padding: 13.33px 0 14.33px 12px;background-color: #F8F8F8;margin-top:11.67px;display: block;}

    .open{display: flex;justify-content: space-between;align-items: center;padding: 13.33px 0 16.67px 0;border-bottom: 1px solid #F5F5F5;}
    .open-left{width: 60%;}
    .open ul{display: flex;justify-content: space-between;align-items: center;flex-wrap: wrap;}
    .open ul li{font-size: 14px;color: #BBBBBB;display: flex;justify-content: space-between;align-items: center;}
    .open ul li span:nth-of-type(2){padding-left: 8.67px;color: #333333;}
    .open-right{text-align: right;}
    .open-right p:nth-of-type(1){color: #17CF84;font-weight: bold;font-size: 20px;margin-top: -2px;}
    .open-right p:nth-of-type(2){color: #BBBBBB;font-size: 12px;}
    .list .bottom{height: 32px;display: flex;justify-content: space-between;align-items: center;}
    .list .bottom p{padding-top: 14.67px;}
    .list .bottom p:nth-of-type(1){color: #999999;font-size: 12px;}
    .list .bottom p:nth-of-type(2){color: #999999;font-size: 12px;}
    .list .bottom p:nth-of-type(2) span{color: #333333;font-size: 14px;}

    /* faq盒子 */
    .faq{width: 300px;border-radius: 12px;background-color: #FFFFFF;position: fixed;top: 40%;left: 0;right: 0;z-index: 888;margin: 0 auto;}
    .faq-title{padding: 17.67px 0 20.33px 0;color: #333333;font-weight: bold;font-size: 16px;text-align: center;}
    .faq-content{border-bottom: 1px solid #F5F5F5;padding: 0 20px 20.33px 20px;line-height: 24px;}
    .faq-bottom{padding: 17.33px 0;text-align: center;color: #FF4F36;font-size: 16px;font-weight: bold;}

    /* 加载loading */
    .isloginTips{width: 150px;border-radius: 9px;background: rgba(0, 0, 0, 0.6);position: fixed;left: 0;right: 0;top: 40%;z-index: 888;color: #FFFFFF;font-weight: bold;font-size: 14px;text-align: center;line-height: 60px;margin: 0 auto;display: flex;justify-content: center;align-items: center;flex-direction: column;}
    .isloginTips p{height: 50px;display: flex;align-items: center;}
    .isloginTips img{width: 40px;height: 40px;display: block;margin-top: 20px;animation:loading 0.75s linear infinite forwards;}
    @keyframes loading {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    
    /*通过fixed固定mescroll的高度*/
	.mescroll {position: fixed;top: 162px;bottom: 0;height: auto;}
</style>


// WEBPACK FOOTER //
// src/components/pingcang.vue